export const businessInfoEndpointConfiguration = {
  url: '/_api/services-catalog/v1/business',
  method: 'GET'
};
//# sourceMappingURL=businessInfo.js.map